export default __webpack_public_path__ + "files/media/fleet-ar-s.d1ed782d.jpg";